<template>
  <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide v-for="(item,index) in swipers" :key="index">
      <img :src="getUrl(item.pic)" @click="linkGoTo(`${item.url}`)">
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
  export default {
    name: 'myswiper',
    props: {
      swipers: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination'
          },
          autoplay: true,
          loop: true,
        },
        url: 'https://ccc.wangwanglive.com'
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    mounted() {
      setTimeout(() => {
         // this.swiper.slideTo(1, 1000, false)
      }, 1000);
    },
    methods: {
      linkGoTo(url) {
        console.log(url);
        window.open(url, "_blank");
      },
      getUrl(url) {
        let partten = /^(http|https).*$/;
        if (partten.test(url)) {
          return url;
        } else {
          return "https://ccc.wangwanglive.com" + url;
        }
      }
    }
  }
</script>
<style scoped>
  img {
    width: 100%;
  }

  ;
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue